import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { ConfirmationDialogModule } from "../confirmation-dialog/confirmation-dialog.module";
import { HeroIconModule } from "../icons/heroIcon.module";
import { LoggingModule } from "../logging/logging.module";
import { MaterialModule } from "../material/material.module";
import { SharedModule } from "../shared/shared.module";
import { TableAddonsModule } from "../shared/table-addons/table-addons.module";
import { WorkspaceEditorComponent } from "./workspace-editor/workspace-editor.component";
import { WorkspaceMembersComponent } from "./workspace-members/workspace-members.component";
import { WorkspaceNavComponent } from "./workspace-nav/workspace-nav.component";
import { WorkspaceSettingsComponent } from "./workspace-settings/workspace-settings.component";
import { WorkspaceAvatarComponent } from "./workspace-avatar/workspace-avatar.component";
import { WorkspacesComponent } from "./workspaces/workspaces.component";

@NgModule({
  declarations: [
    WorkspaceNavComponent,
    WorkspaceEditorComponent,
    WorkspaceSettingsComponent,
    WorkspacesComponent,
    WorkspaceMembersComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    LoggingModule,
    HeroIconModule,
    MaterialModule,
    SharedModule,
    TableAddonsModule,
    ConfirmationDialogModule,
    WorkspaceAvatarComponent,
  ],
  exports: [
    WorkspaceNavComponent,
    WorkspaceEditorComponent,
    WorkspaceSettingsComponent,
    WorkspacesComponent,
    WorkspaceMembersComponent,
  ],
})
export class WorkspaceShellModule {}
